import React from 'react';
import styled from 'styled-components';
import CircularProgress from 'material-ui/CircularProgress';

const Wrapper = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

export default () =>
  <Wrapper>
    <CircularProgress size={80} />
  </Wrapper>;



// WEBPACK FOOTER //
// ./src/components/BigLoadingIndicator.js